export default __webpack_public_path__ + "static/media/notpass.23ddcd6b.svg";